import { defineMessages } from 'react-intl';

export default defineMessages({
  infoIconAlt: {
    id: `app.containers.WorkflowEditor.components.StageSettingCardEmptyState.infoIconAlt`,
    defaultMessage: 'info icon',
  },
});
